import DiffResult from "./DiffResult";

export default DiffResult;
